import { NotFoundErrorMessage } from '@/common/components/NotFoundErrorMessage'
import Spinner from '@/common/components/Spinner'
import { useMineCompany } from '@/features/company/hooks/useMineCompany'
import { CompanyData } from '@/features/company/types/company.type'
import { ComponentType } from 'react'

type ModuleKey = Extract<keyof CompanyData, `${string}_module_enabled`>

export const withModuleGuard = <P extends object>(module: ModuleKey, Component: ComponentType<P>) => {
  const GuardedComponent = (props: P) => {
    const { data: company, isLoading } = useMineCompany()

    if (isLoading) {
      return (
        <div className="flex h-full w-full items-center justify-center py-10">
          <Spinner className="h-6 w-6 fill-blue-800" />
        </div>
      )
    }

    if (!company?.[module]) {
      return (
        <NotFoundErrorMessage className="h-[calc(100vh-64px)]" fallback="/company" buttonText="Ir para Minha empresa" />
      )
    }

    return <Component {...props} />
  }

  return GuardedComponent
}
